import { Image as NbImage } from 'native-base';

import { addWithConfig } from '../../utils';

export const Image = NbImage;

export default addWithConfig(Image);
